import axios from 'axios';
import { currentlySelectedLanguage } from '../helper';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

 const voucherClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_VOUCHERS,
    withCredentials: true
});


  //Request Interceptor
  voucherClient.interceptors.request.use(function (config) {
    config.headers['Accept-Language'] =  currentlySelectedLanguage();
    // config.headers["Authorization"] = `Bearer ${process.env.REACT_APP_TOKEN}`;

      // Do something before request is sent
      return config;
  
  }, function (error) {
      // Do something with request error
      return Promise.reject(error);
  });

  //Response Interceptor
  voucherClient.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    let errorMessage = ""
      switch (error.response.status) {
        case 422:
          errorMessage = error.response.data.errors.denomination_id[0]
          break;

        case 401:
          errorMessage = 'Something went wrong. Login & retry.'
          break;

        default:
          errorMessage = 'Something went wrong. Login & retry.'
          break;
      }

      toast.error(
        errorMessage,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
  }
);

  export default voucherClient;